import Image1 from "../image/masaza/image1.webp";
import Image2 from "../image/masaza/image2.webp";
import Image3 from "../image/masaza/image3.webp";

export const MasazaData = [
  {
    id: 1,
    image: Image1,
    alt: "Image masaza 1",
  },
  {
    id: 2,
    image: Image2,
    alt: "Image masaza 2",
  },
  {
    id: 3,
    image: Image3,
    alt: "Image masaza 3",
  },
];
